module.exports = __webpack_public_path__ + "static/img/5.34867b37.svg";